import { Pipe, PipeTransform } from '@angular/core';

import { add, TimeUnit, pad } from '@fcom/core/utils';

@Pipe({
  name: 'finOffsetToLocalTime',
  pure: false,
  standalone: false,
})
export class OffsetToLocalTimePipe implements PipeTransform {
  transform(offsetMilliseconds: string | number | null = null, d: Date = new Date(Date.now())): string {
    if (offsetMilliseconds === null || offsetMilliseconds === undefined || offsetMilliseconds === '') {
      return '';
    }
    const offset = Number(offsetMilliseconds);

    if (!d || Number.isNaN(offset)) {
      return '';
    }
    const date = add(d, offset, TimeUnit.millisecond);
    return `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}`;
  }
}
